import React from "react";
import { Redirect } from "react-router-dom";

export const FSX_ADMINISTRATION_LEGACY_PREFIX = "/fsxadministration";
export const FSX_ADMINISTRATION_CANONICAL_PREFIX = "/wf-administration";

export const toCanonicalAdministrationPath = (pathname = "") => {
    if (
        pathname === FSX_ADMINISTRATION_LEGACY_PREFIX
        || pathname.startsWith(`${FSX_ADMINISTRATION_LEGACY_PREFIX}/`)
    ) {
        return `${FSX_ADMINISTRATION_CANONICAL_PREFIX}${pathname.slice(FSX_ADMINISTRATION_LEGACY_PREFIX.length)}`;
    }
    return pathname;
};

// Hash is read here because a browser fragment never reaches an edge or HTTP redirect.
export const toCanonicalAdministrationLocation = (location, windowHash = "") => ({
    pathname: toCanonicalAdministrationPath(location?.pathname),
    search: location?.search || "",
    hash: location?.hash || windowHash || "",
    state: location?.state
});

export const LegacyFsxAdministrationRedirect = ({ location }) => (
    <Redirect
        to={toCanonicalAdministrationLocation(
            location,
            typeof window !== "undefined" ? window.location.hash : ""
        )}
    />
);
